import React from "react";
import { FormLabelConfig } from "../types";
import classNames from "classnames";
import ToolTip from "shared/components/tooltip";
import Size from "shared/enums/Size";
import DisplayIcon from "shared/form/core/displayIcon";

//TODO: SF/SR update css
function FormLabel({ htmlFor = "", addFormLabelClass = true, ...props }: FormLabelConfig) {
  const computedClassNames = React.useMemo(
    () =>
      classNames(props.className, {
        form_label: addFormLabelClass,
        [`form_label--${props.variant}`]: props.variant,
        [`form_label--${props.size}`]: props.size,
        [`form_label--withAdditionalLabel`]: props.additionalLabel
      }),
    [props.className, props.variant, props.size, props.additionalLabel, addFormLabelClass]
  );

  if (!props.label) {
    return null;
  }

  return (
    <label
      id={props.id}
      htmlFor={htmlFor}
      className={computedClassNames}
      title={props.showTitle ? (typeof props.label === "string" ? props.label : undefined) : ""}>
      {props.iconUrl && <DisplayIcon iconUrl={props.iconUrl} />}
      {props.label}
      {props.required && <span className="form_label--required">*</span>}
      {props.additionalLabel && <i>{props.additionalLabel}</i>}
      {props.infoLabel && <ToolTip content={props.infoLabel} size={Size.SMALL} />}
      {props.warningText && <div className="warningText">{props.warningText}</div>}
      {props.action && <div className="actionText">{props.action}</div>}
    </label>
  );
}

export default FormLabel;
